import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { getContentByJenis } from "../../services/api";
import "../Dokumen/Dokumen.css";

const VisiMisi = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await getContentByJenis("visi");
      if (response.data.success) {
        setContent(response.data.data.isi);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching content:", error);
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <Container>
          <h1>Visi Misi</h1>
        </Container>
      </div>

      <Container className="content-section">
        {loading ? (
          <div className="loading-container">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="loading-text">Memuat visi misi...</p>
          </div>
        ) : (
          <div className="document-content">
            {content ? (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
              <div className="empty-state">
                <div className="empty-state-icon">🎯</div>
                <h3>Belum Ada Konten</h3>
                <p>Visi misi organisasi belum tersedia.</p>
              </div>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default VisiMisi;
